<div class="body">
    <div class="fotoPresentacion">
        <div class="app-radio-inicio">
            <app-radio-new></app-radio-new>
        </div>
    </div>
    <div class="arrow-down"></div>
    <div class="mt-4">
        <app-publicidad></app-publicidad>
    </div>
    <div class="recent mt-4">
        <h3 class="textoTituloAlt mb-5">ÚLTIMAS NOTICIAS</h3>
        <app-recent-slides [newss]="newsObserver"></app-recent-slides>
    </div>
    <div class="category-slides" id="moveCategory">
        <p class="textoTituloAlt pt-2">CATEGORIAS</p>
        <app-category-slides [categorias]="categorys" (openCategorySel)="cambiarCategoria($event.name)">
        </app-category-slides>
    </div>
    <mat-divider class="matDivider"></mat-divider>
    <div class="trianguloPadre">
        <div class="triangle-down"></div>
    </div>
    <div class="new-cont" id="tpid" *ngIf='noticiaActual'>
        <div class="sectionTop">
            <h3 class="textoTituloAlt">NOTICIAS</h3>
            <div class="new-title">
                <p>{{ noticiaActual.title | truncate:"80" }}</p>
            </div>
            <div class="row m-0">
                <div class="col-lg-9 p-0">
                    <div class="img-cont">
                        <img src="{{noticiaActual.image}}">
                    </div>
                    <div class="text-cont">
                        <div class="contenedor-titulo">
                            <p> Fuente: {{ noticiaActual.source }} </p>
                            <p>
                                Cochabamba,
                                {{noticiaActual.dateOfNew.toDate().getDate()}}/{{noticiaActual.dateOfNew.toDate().getMonth() + 1}}/{{noticiaActual.dateOfNew.toDate().getFullYear()}}
                            </p>
                        </div>
                        <div class="contenedor-noticia">
                            <p>
                                {{noticiaActual.description|truncate:'500'}}
                            </p>
                        </div>
                        <button mat-raised-button color="warn" routerLink="/noticia/{{noticiaActual.id}}">
                            Ver Mas
                        </button>
                        <button mat-stroked-button color="warn" class="ml-2" (click)="movesCategory()">
                            Ver Categorías
                        </button>
                    </div>
                </div>
                <div class="col-lg-3 p-0">
                    <div class="sugest-list">
                        <div class="tituloCat">SUGERENCIAS</div>
                        <mat-list role="list" class="sugerencias">
                            <mat-list-item role="listitem" class="sugerencias-image" *ngFor="let element of datasourcenew"
                                infinite-scroll
                                [infiniteScrollDistance]="0.5"
                                [infiniteScrollThrottle]="50"
                                [infiniteScrollContainer]="selector"
                                [fromRoot]="true"
                                [infiniteScrollDisabled]="disabledScroll"
                                (scrolled)="llenarDataSourceNew()">
                                <div class="contenedor-image-centrar">
                                    <img class="col-12 p-0" src="{{element.image}}" alt="">
                                    <div class="centrear-image-sugerencias">
                                        <div class="contenedor-texto-sugerencias"
                                            [ngClass]="{'contenedor-texto-sugerenciasB': noticiaActual.id == element.id }"
                                            (click)="cambiar(element.id)">
                                            <div class="centrear-texto-sugerencias">
                                                <p>{{element.autor | truncate:'65'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sugest-slides">
        <div>
            <p class="textoTituloAlt">SUGERENCIAS</p>
        </div>
        <div class="contenedor-principal">
            <app-sugest-slider style="width: 100%" [noticias]="datasourcenew" (openNotiSel)="cambiar($event)" (llenarDatos)="llenarDataSourceNew()">
            </app-sugest-slider>
        </div>
    </div>
    <mat-divider class="matDivider"></mat-divider>
    <div class="trianguloPadre">
        <div class="triangle-down"></div>
    </div>
    <div class="sectionBottom pt-4">
        <div class="last-video" *ngIf="currentVideo">
            <h3 class="textoTituloAlt">ULTIMO VIDEO</h3>
            <div class="iframe-cont embed-responsive embed-responsive-16by9">
                <iframe [src]="currentVideo.root | youtubeSafeUrl" scrolling="no" frameborder="0" allowfullscreen="true"
                    allow="autoplay" webkitallowfullscreen="true" mozallowfullscreen="true" class="embed-responsive-item">
                </iframe>
            </div>
        </div>
        <!-- ESPACIO PUBLICITARIO -->
        <div class="publicidad">
            <app-publicidad></app-publicidad>
        </div>
        <!-- ESPACIO PUBLICITARIO END -->
    </div>
    <footer>
        <app-footer-new></app-footer-new>
    </footer>
</div>
